import { useTranslation } from 'react-i18next';

export default function TrustSection() {
  const { t } = useTranslation();

  const items = [
    { icon: 'ri-checkbox-circle-line', titleKey: 'trust_1_title', descKey: 'trust_1_desc' },
    { icon: 'ri-truck-line', titleKey: 'trust_2_title', descKey: 'trust_2_desc' },
    { icon: 'ri-shield-check-line', titleKey: 'trust_3_title', descKey: 'trust_3_desc' },
    { icon: 'ri-refresh-line', titleKey: 'trust_4_title', descKey: 'trust_4_desc' },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 tracking-tight mb-3">
            {t('trust_title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((item, index) => (
            <div
              key={index}
              className="group p-5 md:p-6 rounded-xl bg-white border border-background-200/60 hover:border-primary-300/50 hover:shadow-md transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-lg md:text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                {t(item.titleKey)}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {t(item.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}